<template>
    <div class="base-imagebox" :style="{ width: boxWidth, ...wrapStyle }">
        <div class="base-imagebox__wrap">
            <header class="base-imagebox__header">
                <el-tooltip :content="title" placement="top">
                    <span>{{ title }}</span>
                </el-tooltip>
            </header>
            <main class="base-imagebox__body">

                <div class="base-imagebox__desc">
                    <slot>
                        <el-button style="margin:5px" icon="el-icon-view" type="primary" v-if="fileType!=='其他'" @click="openVideoForm(audioUrl)" plain>{{ '预览'
                            }}</el-button>
                            <base-link style="margin:5px"
                            slot="header"
                            href="/bzmj/admin/Audio/download"
                            :query="{ id: audioFileId, project_system_tag: 'nps' }"
                             :disabled="!audioFileId"
                            class="mr10"
                             >
                            <el-button icon="el-icon-download" type="primary" @click="downloadFile(audioFileId)" plain>{{
                             '下载' }}</el-button> </base-link>
                    </slot>
                </div>
            </main>
        </div>
        <viewer :images="images" :index="0" ref="viewer">
            <img v-for="(image, index) in images" :key="index" style="display: none;" :src="image" />
        </viewer>
    </div>
</template>

<script>

export default {
    name: 'BaseAudiobox',


    inheritAttrs: false,

    props: {
        title: String,
        audioUrl: String,
        fileType:String,
        audioFileId:Number,
        coverURL: String,
        label: String,
        desc: String,
        width: [String, Number],
        gutter: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            dialogLoading: '',
            img: '',
            images: [],
            playerOptions: {
                video: {
                    url: ''
                },
                autoplay: true,
                preload: 'auto',
                volume: 0.7,
                screenshot: true,
                airplay: true,
                hotkey: true,
                theme: '#FADFA3',
                loop: true,
                lang: 'zh-cn',
                mutex: true,
                // 在这里设置 DPlayer 的配置选项
            }
        }
    },
    methods: {
        async openVideoForm(url) {
            console.log(this.fileType);
            /* this.playerOptions.video.url = url;*/
            if (this.fileType === 'video') {
                this.playerOptions.video.url = url;
                this.$msgbox({
                title: this.title,
                showConfirmButton: false,
                message: (<base-video ref="audio"  {...{ props: { options: this.playerOptions } }} key={Date.now()} />),
                customClass: 'dialog__update-data',
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        this.$refs.audio.close();
                        done()
                    } else {
                        this.$refs.audio.close();
                        done()
                    }
                }
            }).then(null, () => { })

            }else if(this.fileType === 'audio') {
                this.$msgbox({
                title: this.title,
                message: (<base-audio ref="audio" {...{ props: { AudioSrc: url } }} key={Date.now()} />),
                showConfirmButton: false,
                customClass: 'dialog__update-data',
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        this.$refs.audio.close();
                        done()
                    } else {
                        this.$refs.audio.close();
                        done()
                    }
                }
            }).then(null, () => { })

            }else if(this.fileType === 'image') {
                this.images = []
                this.images.push(url)
                const viewer = this.$refs.viewer

                viewer && viewer.$viewer.show()
            }
           
        },
        async downloadFile(audioFileId) {
           
            this.$emit('download',audioFileId);
             

        }
    },
    computed: {
        boxWidth() {
            return /^\d+(\.\d+)?$/.test(String(this.width)) ? `${this.width}px` : this.width
        },
        wrapStyle() {
            if (this.gutter > 0) {
                const padding = Math.floor(this.gutter / 2) + 'px'
                return {
                    padding: `0 ${padding} ${padding}`
                }
            }
            return {}
        }
    }
}
</script>

<style lang="scss">
.base-imagebox {
    display: inline-block;
    width: 100%;
    height: 5%;

    .base-imagebox__wrap {
        position: relative;
        height: 50px;
        border: 1px solid $--border-color-light-1;
        border-radius: 2px;
    }

    .base-imagebox__header {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding: 0 20px;
        width: 100%;
        height: 37px;
        line-height: 37px;
        background-color: #f8f8f8;
        text-align: center;
        font-size: 13px;
        @include ellipsis;
        z-index: 2;
    }

    .base-imagebox__body {
        padding: 47px 20px 10px;
        height: 100%;
        overflow: auto;
    }

    .base-imagebox__inner {
        margin-bottom: 10px;
        width: 100%;
        height: 50px;
        border-radius: 4px;
        overflow: hidden;
        text-align: center;

        .el-image {
            width: 100%;
            height: 100%;
        }
    }

    .base-imagebox__desc {
        color: $--color-text-primary;
        text-align: center;
        font-size: 12px;
    }
}

.popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    max-width: 80%;
    max-height: 80%;
    background-color: #fff;
    overflow: hidden;
    padding: 20px;
}

.el-message-box[class*="dialog__update-data"] {
    margin: 1%;
    width: 40%;
    /* 在这里添加你想要应用于.dialog__update-data的样式 */
}
</style>